import { transformToObject } from '@lib/utils/error'
import { logError, LogErrorMetrics } from '../felog'

export const logDataLayerPushError = (e: unknown, dataLayerVariable: string, logErrorMetrics?: LogErrorMetrics) => {
  logError(
    `Error pushing ${dataLayerVariable} to GTM Data Layer`,
    logErrorMetrics || LogErrorMetrics.GTMDataLayerPushError,
    {
      error: transformToObject(e as Error),
    }
  )
}
